import React from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

const SideNavLink = props => (
  <Link onClick={props.onClick} to={props.to} className='sans-serif black ttu norms-12 fw5 lh-solid st-tracked db mt2 pt3 pb2 bb b--light-gray no-underline'>
    <div className='pb1'>
      {props.children}
    </div>
  </Link>
)

export default class SideNav extends React.Component {
  static propTypes = {
    isShown: PropTypes.bool,
    onClickOverlay: PropTypes.func,
  }

  componentDidMount () {
    this.sideNavRoot = document.getElementById('sidenav-root')
    this.el = document.createElement('div')
    this.sideNavRoot.appendChild(this.el)
  }

  componentWillUnmount () {
    this.sideNavRoot.removeChild(this.el)
  }

  render () {
    const shadowClass = this.props.isShown
      ? 'shadow-3'
      : ''

    if (!this.el) {
      return null
    }

    return ReactDOM.createPortal(
      [
        this.props.isShown ? (
          <div key='overlay'
            className='fixed top-0 left-0 vh-100 w-100 bg-black-30 z-999'
            onClick={this.props.onClickOverlay}
          />
        ) : null,
        <div key='side'
          className={`dn-l fixed vh-100 w-80 bg-white webkit-scroll z-999 transition-left top-0 ${shadowClass}`}
          style={{
            left: this.props.isShown ? '0' : '-80%',
          }}
        >
          <nav className='st-mh3'>
            <SideNavLink onClick={this.props.onClickOverlay} to='/'>Welcome</SideNavLink>
            <SideNavLink onClick={this.props.onClickOverlay} to='/departments'>Departments</SideNavLink>
            <SideNavLink onClick={this.props.onClickOverlay} to='/locations'>Locations</SideNavLink>
          </nav>
        </div>,
      ],
      this.el,
    )
  }
}
